// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3sCzt","actions":"GroupTable_actions__3ii7Z","deleteModalFooter":"GroupTable_deleteModalFooter__3O4v2"};